"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosEMVDeviceCreateInputSchema = exports.APosEMVDeviceSchema = exports.APosEMVDeviceHealthSchema = exports.APosEMVDeviceStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosEMVDeviceStatusSchema = zod_1.z.enum([
    'active', 'inactive', 'pairing', 'error', 'offline',
    'online', 'busy', 'unassigned',
]);
exports.APosEMVDeviceHealthSchema = zod_1.z.object({
    txnToday: zod_1.z.number().int().nonnegative().default(0),
    txnMonth: zod_1.z.number().int().nonnegative().default(0),
    uptime30d: zod_1.z.number().min(0).max(100).default(0),
    avgLatencyMs: zod_1.z.number().nonnegative().default(0),
});
exports.APosEMVDeviceSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    deviceId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    terminalId: zod_1.z.string().optional(),
    registerId: zod_1.z.string().nullable().optional(),
    deviceName: zod_1.z.string().min(1).max(100),
    manufacturer: zod_1.z.string().optional(),
    model: zod_1.z.string().optional(),
    serialNumber: zod_1.z.string().optional(),
    firmwareVersion: zod_1.z.string().optional(),
    connectionType: zod_1.z.enum(['usb', 'bluetooth', 'wifi', 'ethernet', 'cloud']),
    ipAddress: zod_1.z.string().optional(),
    macAddress: zod_1.z.string().optional(),
    gateway: zod_1.z.string().min(1),
    gatewayDeviceId: zod_1.z.string().optional(),
    terminalIdNmi: zod_1.z.string().optional(),
    /** Integration class derived from the Device Model at registration.
     *  Absent on legacy records → treat as 'cloud'.
     *  Must list every id in `PAYMENT_DEVICE_CONFIGS` that has a profile —
     *  'dejavoo_cloud' had drifted out of this enum while rows carrying it were
     *  already being written. */
    deviceClass: zod_1.z.enum([
        'cloud', 'nmi_direct_vp3350', 'dejavoo_spin_usb', 'dejavoo_spin_cloud', 'dejavoo_cloud', 'dejavoo_rubytill_pay',
        'sunbay_tapro', 'magtek_teconnect',
    ]).optional(),
    supportedMethods: zod_1.z.array(zod_1.z.enum(['chip', 'swipe', 'contactless', 'manual'])).default(['chip']),
    status: exports.APosEMVDeviceStatusSchema.default('inactive'),
    lastSeenAt: zod_1.z.number().optional(),
    lastTransactionAt: zod_1.z.number().optional(),
    lastHeartbeat: zod_1.z.string().nullable().optional(),
    lastWebhookAt: zod_1.z.string().nullable().optional(),
    pairedAt: zod_1.z.string().nullable().optional(),
    pairedBy: zod_1.z.string().nullable().optional(),
    health: exports.APosEMVDeviceHealthSchema.optional(),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosEMVDeviceCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    terminalId: zod_1.z.string().optional(),
    deviceName: zod_1.z.string().min(1).max(100),
    manufacturer: zod_1.z.string().optional(),
    model: zod_1.z.string().optional(),
    serialNumber: zod_1.z.string().optional(),
    connectionType: zod_1.z.enum(['usb', 'bluetooth', 'wifi', 'ethernet']),
    ipAddress: zod_1.z.string().optional(),
    macAddress: zod_1.z.string().optional(),
    gateway: zod_1.z.string().min(1),
    gatewayDeviceId: zod_1.z.string().optional(),
    supportedMethods: zod_1.z.array(zod_1.z.enum(['chip', 'swipe', 'contactless', 'manual'])).optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=emv-device.schema.js.map